import util from '../util'

let controller = 'ComissaoParceiro'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetTarifasParceiro: function (dto,options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/ListarComissoes', dto)
    },
    GetTarifasParceiroDetalhes: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/ListarComissoesDetalhes', dto)
    }, 
    Aprovar: function (dto) {
        return util.Axios.Post(controller + '/Repasse/Aprovar',dto)
    },
    Cancelar: function (dto) {
        return util.Axios.Post(controller + '/Repasse/Cancelar', dto)
    }
})
